module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.get_class()
  }, [_c('div', {
    staticClass: "mb3 f4"
  }, [(_vm.status === 'DRAFT') ? _c('div', [_c('div', {
    staticClass: "white mh3 mh4-ns dib",
    staticStyle: {
      "float": "right"
    }
  }, [_c('router-link', {
    staticClass: "no-underline black",
    attrs: {
      "to": "/claims/"
    }
  }, [_c('ak-button', {
    attrs: {
      "bordered": "",
      "thin": "",
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.delete_claim.apply(null, arguments)
      }
    }
  }, [_vm._v("Delete")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "cera-round-pro-medium"
  }, [_vm._v(_vm._s(_vm.$t('titles.claimsid', {
    claimsid: 'Claim'
  })) + " #" + _vm._s(_vm.id))]), _vm._v(" "), _c('span', {
    staticClass: "cera-round-pro-medium"
  }, [_vm._v("(" + _vm._s(_vm.status_text) + ")")])]), _vm._v(" "), (!_vm.featureFlagMultiLossTypeActive) ? _c('div', {
    staticClass: "mv3"
  }, [_vm._v("\n    " + _vm._s(_vm.devices.length) + "\n    " + _vm._s(_vm.devices.length === 1 ? 'item' : 'items') + " - " + _vm._s(_vm.lossType) + "\n  ")]) : _c('div', _vm._l((_vm.claimDevices), function(claim_device) {
    return _c('div', {
      key: claim_device.id
    }, [_c('span', {
      staticClass: "inter; font-size:1rem;"
    }, [_vm._v(_vm._s(claim_device.brand) + " " + _vm._s(claim_device.model))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "inter; font-size:1rem;"
    }, [_vm._v(_vm._s(claim_device.nickname))]), _c('br'), _vm._v(" "), _c('div', _vm._l((claim_device.loss_types), function(loss_type) {
      return _c('small', {
        key: loss_type.id,
        staticClass: "loss-type-label cera-round-pro",
        style: (_vm.get_label_style())
      }, [(loss_type.name == 'Other') ? _c('span', [_vm._v(_vm._s(loss_type.loss_type_category) + " - ")]) : _vm._e(), _vm._v(_vm._s(loss_type.name) + "\n          ")])
    }), 0), _vm._v(" "), _c('br')])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "f6 silver inter"
  }, [_vm._v(_vm._s(_vm.filed_days_ago))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f3b0cbd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClaimCard.vue
// module id = 1356
// module chunks = 0